import script from "./EditInterventionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditInterventionPage.vue?vue&type=script&setup=true&lang=js"

import "./EditInterventionPage.vue?vue&type=style&index=0&id=44bb92aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44bb92aa"]])

export default __exports__